<template>
	<div>
		<nav-bar id="navbar" />
		<div id="maincontent">
			<slot />
		</div>
		<Footer id="footer" />
	</div>
</template>

<script>
	// COMPONENTS
    import NavBar from '@/components/NavBar/Index'
    import Footer from '@/components/Footer/Index'
    
	export default {
		name: 'default_static',
		components: {
            'nav-bar': NavBar,
            Footer : Footer,
		},
	}
</script>
